import React from "react";
import styled from "styled-components";
import { Image, ImageProps } from "../Image/Image";

export interface BackgroundImageProps extends ImageProps {
    children?: React.ReactNode;
}

const BackgroundImageRoot = styled(Image)<BackgroundImageProps>`
    background-image: url(${({ src }) => src});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
`;

export const BackgroundImage: React.FC<BackgroundImageProps> = ({ src, alt, children, className, ...props }) => {
    // Use transient prop $src to prevent it from being passed as HTML attribute
    return (
        <BackgroundImageRoot src={src} alt={alt} className={`BackgroundImage ${className || ""}`} {...props}>
            {children}
        </BackgroundImageRoot>
    );
};

export default BackgroundImage;
